import { FC, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Setting } from '../../types/constant/PagesPropsType';
import { ReactiveModal } from '../ReactiveModal/ReactiveModal';
import { MessageModal } from '../MessageModal/MessageModal';
import { Subscription } from '../../types/constant/SubscriptionType';
import { MessageModalViewType } from '../../types/view/MessageModalViewType';
import { ReactiveModalViewType } from '../../types/view/ReactiveModalViewType';
import { useUpdateSubscriptionStatus } from '../../hooks/use-update-subscription-status';
import { useSubscriptionDetail } from '../../hooks/use-subscription-detail';
import reactiveSubscription from '../../assets/scss/SubscriptionList/ReactiveSubscription.module.scss';
import { postMessageGtag } from '../../utils/trackClick';
import type { SubscriptionProductViewItem } from '../../utils/subscriptionDetail/types';
import { SubscriptionListProductThumbnails } from './SubscriptionListProductThumbnails';

export const ReactiveSubscription: FC<{
  subscriptionItem: Subscription;
  setting: Setting;
  productDisplayUnits: Record<string, string>;
  subscribedItems?: SubscriptionProductViewItem[] | null;
}> = ({ subscriptionItem, setting, productDisplayUnits, subscribedItems }) => {
  // 定期オトク便再開のモーダルのデータ
  const [reactiveModal, setReactiveModal] = useState<ReactiveModalViewType | null>(null);
  // リクエスト中に別のリクエストを飛ばさないためのフラグ
  const [loading, setLoading] = useState(false);
  // メッセージモーダルのデータ
  const [messageModal, setMessageModal] = useState<MessageModalViewType | null>(null);
  // 画面内で呼び出されるAPI一覧
  const { subscription, setSubscription } = useSubscriptionDetail(
    setting,
    subscriptionItem.subscriptionContractId
  );
  const history = useHistory();

  const { activeSubscription } = useUpdateSubscriptionStatus();

  // 再開ボタンをクリックした時の挙動
  const handleReactiveSubscription = () => {
    if (subscription && subscription.subscriptionLines) {
      // if (!reactiveModal) return;
      setReactiveModal({
        leadText: 'お好きな商品を組み合わせて<br />あなただけの定期オトク便を<br/>お楽しみください',
      });
    }
  };

  const thumbCount =
    subscribedItems != null && subscribedItems.length > 0
      ? subscribedItems.length
      : subscriptionItem.subscriptionLines.length;
  const productCountClass = thumbCount >= 4 ? 'start-left' : '';

  return (
    <div className={reactiveSubscription.reactiveSubscription}>
      {/* 商品リスト */}
      <div className="subscription-history__productlist-wrapper">
      <div className={`subscription-history__productlist  ${productCountClass}`}>
        <SubscriptionListProductThumbnails
          subscribedItems={subscribedItems ?? null}
          fallbackLines={subscriptionItem.subscriptionLines}
          productDisplayUnits={productDisplayUnits}
          grayedOut
        />
        </div>
      </div>
      <button
        className={`btn ${reactiveSubscription.reactiveModalBtn}`}
        onClick={() => {
          handleReactiveSubscription();
          postMessageGtag('click_modal_open_restart', 'top');
        }}
      >
        定期オトク便を再開する
      </button>

      <div className={reactiveSubscription.reactiveAttention}>
        再開後すぐに注文は確定されません。
      </div>

      {/* 契約再開のモーダル */}
      <ReactiveModal
        active={reactiveModal !== null}
        closeFunc={() => setReactiveModal(null)}
        ReactiveModal={reactiveModal}
        clickSubmitFunc={() => {
          setLoading(true);
          activeSubscription(
            setting,
            subscription!,
            () => {
              window.parent.postMessage({ action: 'fixedBtnShow' }, '*');
              history.push('/');
              window.location.reload();
            },
            () => {
              setMessageModal({
                message: '再開に失敗しました',
              });
            },
            () => {
              setReactiveModal(null);
              setLoading(false);
            }
          );
        }}
        loading={loading}
      />
      {/* メッセージのみ表示するモーダル */}
      <MessageModal
        active={messageModal !== null}
        closeFunc={() => setMessageModal(null)}
        messageModal={messageModal}
      />
    </div>
  );
};
